import React, { useEffect, useState } from 'react';
import { Search, Loader2 } from 'lucide-react';
import { Input } from '../ui/input';
import { getResearch, apiError } from '../../lib/research';
import { LocaleText } from '../../i18n/Locale';

export const CoinSearch = ({ onSelect }) => {
  const [q, setQ] = useState(''), [rows, setRows] = useState([]), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setRows([]); setError(''); setBusy(false);
    if (q.trim().length < 2) return;
    const abort = new AbortController();
    setBusy(true);
    const timer = setTimeout(async () => {
      try {
        const result = await getResearch('/crypto/search', { params: { q: q.trim() }, signal: abort.signal });
        if (!abort.signal.aborted) setRows(result.data);
      } catch (e) { if (!abort.signal.aborted) setError(apiError(e)); }
      finally { if (!abort.signal.aborted) setBusy(false); }
    }, 350);
    return () => { clearTimeout(timer); abort.abort(); };
  }, [q, retry]);
  return <div className="crypto-coin-search" data-testid="crypto-coin-search">
    <label className="crypto-search-input"><Search size={17} /><Input value={q} onChange={e => setQ(e.target.value)} maxLength={60} aria-label="Search CoinGecko coins" placeholder="Search coin name or symbol…" data-testid="crypto-coin-search-input" autoComplete="off" />{busy && <Loader2 size={17} className="animate-spin" data-testid="crypto-search-loading" />}</label>
    {q.trim().length >= 2 && <div className="crypto-search-results" data-testid="crypto-search-results">
      {error ? <div role="alert" data-testid="crypto-search-error"><LocaleText value={error} /><button onClick={() => setRetry(n => n+1)} data-testid="crypto-search-retry">Retry search</button></div> : !busy && !rows.length ? <p data-testid="crypto-search-empty">No matching coins.</p> : rows.map(coin => <button key={coin.coin_id} data-testid={`crypto-search-select-${coin.coin_id}`} onClick={() => { onSelect(coin); setQ(''); }}><strong>{coin.name} <small>{coin.symbol}</small></strong><span>{coin.coin_id}</span></button>)}
      <button onClick={() => setQ('')} data-testid="crypto-search-close">Close search</button>
    </div>}
  </div>;
};